__turbopack_context__.v({
  "popover-trigger-width": "popover-module__ELtYJa__popover-trigger-width",
});
